<ihd-modal class="c-modal--xs c-modal--primary" [createOverlay]="false">
    <div class="c-modal__header">
        <ihd-tabs [items]="tabItems"></ihd-tabs>
        <ihd-button-group class="ml-auto c-btn-group--gap-2">
            <div class="c-btn-group__vert-divider--fill c-btn-group__vert-divider"></div>
            <button ihdIconButton icon="close" class="x-modal__icon-btn c-icon-btn--xs" (click)="closeDialog()">
                <ihd-tooltip>{{ 'Common.Close' | translate }}</ihd-tooltip>
            </button>
        </ihd-button-group>
    </div>
    <div class="c-modal__body">
        <div class="c-modal__body-content c-modal__body--no-scroller"
             [class.is-hidden]="!isReady">
            <ng-container *ngIf="!isStripeInitError; else stripeError;">
                <div class="c-form-group">
                    <div class="l-row">
                        <div class="l-col-5">
                            <label>{{ 'Billing.Details.CardNumber' | translate }}</label>
                            <div id="card-number" class="c-form-control c-form-control--stripe"></div>
                        </div>
                        <div class="l-col-4">
                            <label>{{ 'Billing.Details.Expiry' | translate }}</label>
                            <div id="card-expiry" class="c-form-control c-form-control--stripe"></div>
                        </div>
                        <div class="l-col-3">
                            <label>{{ 'Billing.Details.CVC' | translate }}</label>
                            <div id="card-cvc" class="c-form-control c-form-control--stripe"></div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #stripeError>
                <div class="c-alert c-alert--warning text-left">
                    <div class="c-alert__container">
                        <ihd-icon class="c-icon--warning-bubble c-alert__icon align-self-center pl-0 mr-3"
                                    name="bell"></ihd-icon>

                        <div class="c-alert__body">
                            <div class="c-alert__title">{{'Errors.Stripe.Title' | translate}}</div>
                            <div class="c-alert__description" [innerHtml]="stripeErrorDesc"></div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="c-modal__body-footer px-0 mt-2">
                <div class="c-form-group">
                    <div class="d-flex justify-content-end">
                        <button ihdButton type="button" (click)="submit()"
                            class="c-btn--primary c-btn--lg c-btn--wlg"
                            [disabled]="isLoading || isStripeInitError">
                            {{'Billing.Subscription.Update.CTA' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="c-modal__body-content c-modal__body--no-scroller c-modal__body--has-loader"
             *ngIf="!isReady">
            <ihd-loader class="c-loader--xs c-loader--horz-center"></ihd-loader>
        </div>
    </div>
</ihd-modal>
